import http from "../api/axios-auth-php-frontend";
import axios from "../api/axios-auth";
class FrontendService {
    fetchShippingDetail(data) {
      return http.get("bestbuy/order/tracking", { params: data});
    }
    fetchBestBuySalesTax(data) {
      return http.post("bestbuy/order/tax", data);
    }
    submitNpsSurvey(data) {
      return http.post("nps/survey/create", data);
    }
    showNpsPopup() {
      return http.get("nps/survey/showPopup");
    }
    closeNpsPopup() {
      return http.get("nps/survey/closePopup");
    }
    getCart(data) {
      return axios.get("/me/cart", { params: data });
    }
    clientFundingConfiguration(data) {
      return axios.post("/dv-adm/toggle-funding-flow", data);
    }
    getClientBalance(data) {
      return axios.get("/dv-adm/stripe-balance", { params: data });
    }
    updateBalance(data) {
      return axios.put("/dv-adm/update-stripe-balance", data);
    }

    // Funding API
    doRecharge(data) {
      return axios.post("/hr-adm/chargecustomerallocatepoints", data);
    }
    deletePaymentMethod(data) {
      return axios.put("/hr-adm/delete-payment-method", data);
    }
    paymentHistory(data) {
      return http.get("client/paymentHistory", { params: data });
    }

    addFundingSettings(data) {
      return http.post("funding/settings/create", data);
    }
    getFundingSettings() {
      return http.get("funding/settings/list");
    }
    updateFundingSetting(data) {
      return http.post("funding/settings/update", data);
    }
    deleteFundingSetting(data) {
      return http.delete("funding/settings/delete", { params: data });
    }

    //Catalog Grid
    toggleClientGridSetting(data) {
      return axios.put("/dv-adm/toggle-customized-grid-layout", data);
    }
    createCatalogGrid(data) {
      return axios.post("/dv-adm/create-customized-grid-layout", data);
    }
    createGridItem(data) {
      return axios.post("/dv-adm/create-customized-grid-item", data,  {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      });
    }
    getCatalogGrids(data) {
      return axios.get("/dv-adm/get-customized-grids-for-client", { params: data });
    }
    getCatalogGridsForUser(data) {
      return axios.get("/company/get-customized-grids", { params: data });
    }

    //Curated Items
    toggleClientCuratedSetting(data) {
      return axios.put("/dv-adm/toggle-curated-item", data);
    }
    createOrUpdateCuratedItem(data) {
      return axios.post("/dv-adm/create-curated-item", data);
    }
    getCuratedList(data) {
      return axios.get("/dv-adm/list-curated-items", { params: data });
    }
    deleteCuratedItems(data) {
      return axios.delete("/dv-adm/delete-curated-item", { params: data });
    }
    addProductToCuratedItem(data) {
      return axios.put("/dv-adm/add-products-to-curated-item", data);
    }
    getCuratedProductsList(data) {
      return axios.get("/dv-adm/get-curated-products", { params: data });
    }
    deleteCuratedItemProduct(data) {
      return axios.put("/dv-adm/remove-products-from-curated-item", data);
    }

    //Curated Items Frontend
    getCuratedItems(data) {
      return axios.get("/me/list-curated-items", { params: data });
    }
    getCuratedItemProducts(data) {
      return axios.get("/me/get-curated-products", { params: data });
    }
    generateOTP(data) {
      return axios.post("/auth/generate-otp", data );
    }
    divvyAdminGenerateOTP(data) {
      return axios.post("/auth/dv-adm-generate-otp", data );
    }
    getMinMaxPoints(data) {
      return axios.get("/company/get-minmax-points", { params: data });
    }
}
  
  export default new FrontendService();